const FETCH_DATA_FAILURE = 'FETCH_DATA_FAILURE';
const FETCH_DATA_REQUEST = 'FETCH_DATA_REQUEST';
const FETCH_DATA_SUCCESS = 'FETCH_DATA_SUCCESS';
const HYDRATE_SORT = 'HYDRATE_SORT';
const SET_SORT = 'SET_SORT';
const RESET_SORT = 'RESET_SORT';
const SET_PAGE = 'SET_PAGE';
const SET_PAGE_SIZE = 'SET_PAGE_SIZE';
const HYDRATE_PAGE = 'HYDRATE_PAGE';
const HYDRATE_PAGE_SIZE = 'HYDRATE_PAGE_SIZE';
const RESET_PAGINATION = 'RESET_PAGINATION';

export default {
    FETCH_DATA_FAILURE,
    FETCH_DATA_REQUEST,
    FETCH_DATA_SUCCESS,
    HYDRATE_SORT,
    SET_SORT,
    RESET_SORT,
    SET_PAGE,
    SET_PAGE_SIZE,
    HYDRATE_PAGE,
    HYDRATE_PAGE_SIZE,
    RESET_PAGINATION,
};
